/** Polls a condition every `intervalMs` until it returns true or `timeoutMs` elapses. */
export function poll(condition: () => boolean, intervalMs: number, timeoutMs: number): Promise<boolean> {
  return new Promise((resolve) => {
    if (condition()) {
      resolve(true);
      return;
    }

    const startTime = Date.now();
    const interval = setInterval(() => {
      if (condition()) {
        clearInterval(interval);
        resolve(true);
        return;
      }
      if (Date.now() - startTime > timeoutMs) {
        clearInterval(interval);
        resolve(false);
      }
    }, intervalMs);
  });
}

export async function waitForElement(selector: string, timeoutMs = 5000): Promise<Element | null> {
  const found = await poll(() => !!document.querySelector(selector), 200, timeoutMs);
  return found ? document.querySelector(selector) : null;
}

function isElementVisible(el: Element): boolean {
  const rect = el.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0;
}

export async function waitForVisibleElement(selector: string, timeoutMs = 10000): Promise<Element | null> {
  const found = await poll(
    () => {
      const el = document.querySelector(selector);
      return !!el && isElementVisible(el);
    },
    200,
    timeoutMs,
  );
  if (!found) return null;
  return document.querySelector(selector);
}
